// Define utility functions for time period tooltips
const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })
}

export const getTimePeriodTooltip = (token: string) => {
    const isSingleTimePattern = /^\d+d$/.test(token)
    const isRangeStartPattern = /^\d+d\.\.$/.test(token)
    const isRangeEndPattern = /^\.\.\d+d$/.test(token)
    const isFullRangePattern = /^\d+d\.\.\d+d$/.test(token)
    const isLifetimePattern = token === '..'

    // Fix precedence issues
    if (isFullRangePattern) {
        return getFullRangeTooltip(token)
    }

    if (isRangeEndPattern) {
        return getRangeEndTooltip(token)
    }

    if (isRangeStartPattern) {
        return getRangeStartTooltip(token)
    }

    if (isSingleTimePattern) {
        return getSingleTimeTooltip(token)
    }

    if (isLifetimePattern) {
        return 'lifetime'
    }

    return null
}

export const getSingleTimeTooltip = (timeString: string) => {
    const days = parseInt(timeString)
    if (isNaN(days)) return null

    const today = new Date()
    const startDate = new Date()
    startDate.setDate(today.getDate() - days)

    return `${formatDate(startDate)} to ${formatDate(today)} (inclusive)`
}

export const getRangeStartTooltip = (timeString: string) => {
    const daysMatch = timeString.match(/^(\d+)d\.\.$/)
    if (!daysMatch || !daysMatch[1]) return null

    const days = parseInt(daysMatch[1])
    if (isNaN(days)) return null

    const today = new Date()
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - days)

    return `From ${formatDate(startDate)} to ${formatDate(today)} (inclusive)`
}

export const getRangeEndTooltip = (timeString: string) => {
    const daysMatch = timeString.match(/^\.\.(\d+)d$/)
    if (!daysMatch || !daysMatch[1]) return null

    const days = parseInt(daysMatch[1])
    if (isNaN(days)) return null

    const endDate = new Date()
    endDate.setDate(endDate.getDate() - days)

    return `All lifetime data up to, and including ${formatDate(endDate)}`
}

export const getFullRangeTooltip = (timeString: string) => {
    const rangeMatch = timeString.match(/^(\d+)d\.\.(\d+)d$/)
    if (!rangeMatch || !rangeMatch[1] || !rangeMatch[2]) return null

    const startDays = parseInt(rangeMatch[1])
    const endDays = parseInt(rangeMatch[2])
    if (isNaN(startDays) || isNaN(endDays)) return null

    const today = new Date()
    const startDate = new Date()
    const endDate = new Date()

    startDate.setDate(today.getDate() - startDays)
    endDate.setDate(today.getDate() - endDays)

    return `${formatDate(endDate)} to ${formatDate(startDate)} (inclusive)`
}
